import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from "../../../../Constants";
const TroubleCallForm = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        callNumber: '',
        buildingSite: '',
        customer: '',
        caller: '',
        superintendent: '',
        manager: '',
        phoneNumber: '',
        status: '',
        priority: '',
        problemClass: '',
        sub: '',
        dispatchNumber: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${API_BASE_URL}/api/callcenter/troublecalls/createTroubleCall`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                credentials: 'include'
            });

            if (response.ok) {
                alert('Trouble call entry created successfully');
                setFormData({
                    callNumber: '',
                    buildingSite: '',
                    customer: '',
                    caller: '',
                    superintendent: '',
                    manager: '',
                    phoneNumber: '',
                    status: '',
                    priority: '',
                    problemClass: '',
                    sub: '',
                    dispatchNumber: '',
                });
                navigate('/call-center/troublecallentry');
            } else {
                throw new Error('Failed to create trouble call entry');
            }
        } catch (error) {
            console.error('Error creating trouble call entry:', error);
            alert('An error occurred while creating trouble call entry');
        }
    };

    const formFields = [
        { label: 'Call Number', name: 'callNumber', type: 'text', required: true },
        { label: 'Building Site', name: 'buildingSite', type: 'text', required: true },
        { label: 'Customer', name: 'customer', type: 'text', required: true },
        { label: 'Caller', name: 'caller', type: 'text', required: true },
        { label: 'Superintendent', name: 'superintendent', type: 'text', required: true },
        { label: 'Manager', name: 'manager', type: 'text', required: true },
        { label: 'Phone Number', name: 'phoneNumber', type: 'text', required: true },
        { label: 'Status', name: 'status', type: 'text', required: true },
        { label: 'Priority', name: 'priority', type: 'select', options: ['1 (HIGH)', '2', '3', '4', '5 (LOW)'], required: true },
        {
            label: 'Problem Class', name: 'problemClass', type: 'select', options: ['ENTRAPMENT',
                'SHUTDOWN',
                'PROBLEM',
                'FOLLOW UP',
                'PRE-SCHEDULED JOB',
                'INSPECTIONS',
                'AM SERVICE',
                'MOBILE SURVEY ITEMS',
                'Planning & Mobilization',
                'STANDBY',
                'MECHANIC INFORMED'], required: true
        },
        {
            label: 'Sub', name: 'sub', type: 'select', options: ['DOOR PROBLEM',
                'NOT RESPONDING TO CALLS',
                'ENTRAPMENT',
                'OFF LEVEL',
                'DOORS STUCK OPEN',
                'DOORS STUCK CLOSED',
                'PENDING APPROVAL OF PROPOSAL',], required: true
        },
        { label: 'Dispatch Number', name: 'dispatchNumber', type: 'text', required: true },
    ];

    return (
        <div className="max-w-lg mx-auto mt-10 p-6">
            <h2 className="text-4xl font-bold mb-6 text-left text-white">Create Trouble Call Entry</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 gap-2">
                    {formFields.map((field) => (
                        <div key={field.name}>
                            <label className="block text-white">{field.label}:</label>
                            {field.type === 'select' ? (
                                <select
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleInputChange}
                                    required={field.required}
                                    className="w-full px-3 py-2 border rounded-md"
                                >
                                    <option value="">Select an option</option>
                                    {field.options.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type={field.type}
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleInputChange}
                                    required={field.required}
                                    className="w-full px-3 py-2 border rounded-md"
                                />
                            )}
                        </div>
                    ))}
                </div>
                <button
                    type="submit"
                    className="w-full py-2 px-4 bg-blue-500 text-white font-semibold rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                >
                    Add Trouble Call Entry
                </button>
            </form>
        </div>
    );
};
export default TroubleCallForm;
